import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import { Box, Grid, IconButton } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../../context/auth";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { BookingManageDialog } from "../../../page/BookingPage/BookingManageDialog";
import {
    BOOKING_STATUS_COLOR_BY_KEY,
    BookingStatusText,
} from "../../../page/BookingPage/BookingStatusText";
import { AddReservationDialog } from "../../dialog/AddReservationDialog/AddReservationDialog";

export const StatusButton = (props) => {
    const { booking } = props;
    const { user } = useAuth();
    const isCompleted = booking.status.status_key === "Completed";
    const statusColor = BOOKING_STATUS_COLOR_BY_KEY[booking.status.status_key] || "black";
    const buttonColor = statusColor;
    const { openDialog } = useDialogBetter();
    const queryClient = useQueryClient();

    const openManageBookingDialog = (booking) => {
        openDialog({
            Component: BookingManageDialog,
            componentProps: { booking },
        });
    };

    const openCreateBookingDialog = (booking) => {
        openDialog({
            Component: AddReservationDialog,
            componentProps: {
                initialCustomerIds: booking.customers.map((c) => c.customer.id),
                initialProductIds: booking.products.map((p) => p.id),
                onSuccess: () => {
                    queryClient.invalidateQueries({ queryKey: ["bookings"] });
                    queryClient.invalidateQueries({ queryKey: ["offers"] });
                },
            },
        });
    };

    const isActive = booking.status.status_name_eng === "Active";

    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{ width: "100%", alignItems: "center", justifyContent: "center", margin: 0 }}
        >
            <Grid item width="80%">
                <Box
                    sx={{ padding: "5px", borderRadius: "5px", border: `2px solid ${statusColor}` }}
                >
                    <BookingStatusText status={booking.status} />
                </Box>
            </Grid>
            <Grid item width={"3rem"}>
                <IconButton
                    disabled={!isCompleted && user?.full_name !== booking.creator}
                    onClick={() =>
                        isActive
                            ? openManageBookingDialog(booking)
                            : openCreateBookingDialog(booking)
                    }
                    sx={{ color: buttonColor }}
                >
                    {isActive ? <TuneOutlinedIcon /> : <UpdateOutlinedIcon />}
                </IconButton>
            </Grid>
        </Grid>
    );
};
